import * as React from 'react'
import { CollapsibleDivConnected } from './CollapsibleDivConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const CollapsibleDivExamples = () => {
  return (
    <div className="CollapsibleDivExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <CollapsibleDivConnected />
      </Provider>
    </div>
  )
}
